import type { FC } from 'react'

import CapturiThemeProvider from '../components/CapturiThemeProvider'
import { PuzzelWidget } from './PuzzelWidget'
import { TestBench } from './testBench/TestBench'
import { theme } from './theme'

export type CallFlow = 'awaiting' | 'alerting' | 'handling' | 'wrapUp'
export type WidgetState = {
  currentCallState: CallFlow
  data: {
    customer: string
    sessionUid: string
    queue: string
    agentUserName?: string
    getTranscription: () => string
    hasTranscription: boolean
  }
  modules: {
    handover: { enabled: false } | { enabled: true; show: boolean }
    voiceBotHandover: { enabled: false } | { enabled: true; show: boolean }
    previousInteractions: { enabled: boolean }
    askCopilot: { enabled: boolean }
    liveSummary:
      | { enabled: false }
      | ({
          enabled: true
          lockSummaryEdit: boolean
        } & (
          | { buttonDisabled: true; reason: string }
          | { buttonDisabled: false; reason: '' }
        ))
  }
  config: {
    waitUntilAnswer: boolean
    legacyApiToken: string
    copilotApiToken: string
  }
}

export const Copilot: FC = () => {
  if (
    import.meta.env.MODE === 'development' &&
    !window.location.search.includes('&full')
  ) {
    return (
      <CapturiThemeProvider theme={theme}>
        <TestBench />
      </CapturiThemeProvider>
    )
  }

  return <PuzzelWidget />
}
